module.exports = __webpack_public_path__ + "media/images/client_footer__background--onlyPhone-5426731aa2c05d96d61cad674ab2d64e.png";